/**
 * ProgressSync — Envía al backend cada intento de caso (diagnóstico + triage).
 *
 * El ProgressTracker local sigue siendo la fuente de verdad del UI (nivel/XP),
 * pero el backend agrega persistencia cross-device y métricas para el profesor.
 *
 * Falla silenciosamente si no hay backend disponible: la app sigue funcionando
 * sin red. Los errores se loggean para diagnosticar pero no rompen la sesión.
 */

import { authService } from './AuthService';

export interface AttemptPayload {
  case_id: string;
  diagnosis_correct: boolean;
  triage_correct: boolean;
  score: number; // 0..100
  duration_seconds: number;
}

export async function recordAttempt(payload: AttemptPayload): Promise<void> {
  if (!authService.isAuthenticated) return;
  try {
    await authService.request('/progress/attempts', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  } catch (error) {
    console.warn('[ProgressSync] no se pudo registrar el intento:', error);
  }
}
